import VideoHeader from './VideoHeader';
import VideoBoard from './VideoBoard.vue';
import SingleVideo from './SingleVideo.vue';
import SingleVideoHeader from './SingleVideoHeader';

const moduleId = 'videos';
class VideoRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/videos/:instance',
        name: 'videos',
        meta: {
          moduleType,
          initiateSyncBeforeNav: true,
          moduleId,
          baseRoute: true,
        },

        components: { default: VideoBoard, header: VideoHeader },
      },

      {
        path: '/videos/:instance/:videoId',
        props: true,
        name: 'video',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: false,
          backPath: (currentRouteParams) => {
            return `/videos/${currentRouteParams.instance}`;
          },
        },

        components: { default: SingleVideo, header: SingleVideoHeader },
      },
    ];
  };
}
const routeHandler = new VideoRouteHandler();
export default routeHandler;
